module.exports = __webpack_public_path__ + "static/media/wom-mas-libre-plus.5b61b8e3.svg";